module.exports = __webpack_public_path__ + "img/chipping4.f204b946.png";